import { getLocaleDateFormat } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStat, CodePanne, ContractType, TechnicienSav } from 'src/app/model/call/call.model';
import { Action, Intervenant, TypeAppel } from 'src/app/model/gestion/gestion';
import { InstallContract } from 'src/app/model/installation/installation.model';
import { CallService } from 'src/app/services/http/call/call.service';
import { GestionActionsSavService } from 'src/app/services/http/gestion/gestion-actions-sav.service';
import { GestionIntervenantsSavService } from 'src/app/services/http/gestion/gestion-intervenants-sav.service';
import { GestionTypesAppelsService } from 'src/app/services/http/gestion/gestion-types-appels.service';
import { UtilsService } from 'src/app/services/tools/utils.service';

@Component({
  selector: 'app-search-calls',
  templateUrl: './search-calls.component.html',
  styleUrls: ['./search-calls.component.scss']
})
export class SearchCallsComponent implements OnInit {
  
  selectedPannes!: CodePanne[];
  public startCP: any;
  public endCP: any;

  get displayedColumn(): string[] {
    const result: string[] = ['date', 'numSerie', 'nom', 'action', 'contrat', 'duree', 'dateMiseEnService', 'departement', 'callState'];
    return result;
  }

  

  constructor(private service: CallService,
    private builder: FormBuilder,
    private utils: UtilsService,
    private appelsSavService: GestionTypesAppelsService,
    private actionsSavService: GestionActionsSavService,
    private intervenantsSavService: GestionIntervenantsSavService, 
    private router : Router,
    private route : ActivatedRoute) { }

  /**
   * Boolean indicating if spinner has to be shown while something is being loaded
   */
  public isLoading: boolean = false;

  /** Types of contracts */
  typesContrat!: ContractType[];

  /**
   * Existing breakdown codes
   */
  codesPannes!: CodePanne[];

  /**
   * List of Calls found
   */
  callStats!: CallStat[];

  /**
   * Search From
   */
  searchForm!: FormGroup;

  /**
   * List of Calls found
   */
   installContracts!: InstallContract[];

  /**
   * Search From
   */
   searchInstallForm!: FormGroup;



  /* List of type appels:  */
  listeTypeAppels !: TypeAppel[];

  /**
  * List of Actions
  */
  listeActionsSav !: Action[];

  /**
   * List of intervenants
   */
  listeIntervenantsSav !: Intervenant[];

  /**
   * List of techniciens sav
   */
  listTechniciensSav !: TechnicienSav[];


  /**
   * List of departements
   */
  listDepartement !: any;


  ngOnInit(): void {

    /** Load all the technicians sav */
    this.service.getIntervenantsSavList().subscribe( (liste) => {
      this.listTechniciensSav = liste;
   });

    /** Load the breakdowns codes available */
    this.service.getCodesPannes().subscribe((codesPannes) => {
      this.codesPannes = codesPannes;
      this.selectedPannes = this.codesPannes; 
    });

    /** Load the contracts types available */
    this.service.getContractsTypes().subscribe((contracts) => {
      this.typesContrat = contracts;
    });

    /* Load the type appels sav */
    this.appelsSavService.getTypeAppelsSavList().subscribe((res) => {
      this.listeTypeAppels = res;
      this.listeTypeAppels = this.listeTypeAppels.filter(function (el) {
        return el.deleted == false;
      })
    });

    /* Load the type appels sav */
    this.actionsSavService.getActionsSavList().subscribe((res) => {
      this.listeActionsSav = res;
      this.listeActionsSav = this.listeActionsSav.filter(function (el) {
        return el.deleted == false;
      })
    });


    /**Load intervenants sav */
    this.intervenantsSavService.getIntervenantsSav().subscribe((res) => {
      this.listeIntervenantsSav = res;
      this.listeIntervenantsSav = this.listeIntervenantsSav.filter(function (el) {
        return el.deleted == false;
      })
    });

    /**Load departements list */
    this.intervenantsSavService.getDepartementsList().subscribe((res) => {
      this.listDepartement = res;
      // this.listDepartement = this.listDepartement.filter(function (el) {
      //   return el.deleted == false;
      // })
    });

    this.searchForm = this.builder.group({
      contractType: [''],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      dateMiseEnService: [''],
      type: [''],
      action: [''],
      intervenant: [''],
      codePanne: [''],
      technicienSav: [''],
      departement: [''],
      validation: ['']
    },
      {
        validator: [
          this.datesValidator
        ]
      }
    );

    this.searchInstallForm = this.builder.group({
      contractTypeInstall: [''],
      operatorDebut: [''],
      startDateContract: [''],
      operatorFin: [''],
      endDateContract: ['']
    }
    );


  }


  onSubmit() {


    if (!this.searchForm.valid) {
      return;
    }
    this.isLoading = true;

    let techValues = 0;
    if (  this.searchForm.controls.technicienSav.value ) {
      techValues = this.searchForm.get('technicienSav')?.value;
    } else {
      techValues = 0;
    }

    this.service.getCallsStats(this.searchForm.controls.contractType.value,
      this.searchForm.controls.startDate.value,
      this.searchForm.controls.endDate.value,
      this.searchForm.controls.dateMiseEnService.value,
      this.searchForm.controls.action.value,
      this.searchForm.controls.intervenant.value,
      this.searchForm.controls.type.value,
      this.searchForm.controls.codePanne.value,
      techValues,
      this.searchForm.controls.departement.value,
      this.searchForm.controls.validation.value
    )

      .subscribe((calls) => {
        this.callStats = calls;
        this.isLoading = false;
      });
  }



  private datesValidator(searchForm: FormGroup) {

    let dateBegin = new Date(searchForm.controls.startDate.value);
    let dateEnd = new Date(searchForm.controls.endDate.value);
    /** Begin date should be at least equal to End date */
    if (dateBegin < dateEnd) {
      return false;
    } else {
      return true;
    }

  }

  public getNiceDate(date: string) {
    return this.utils.getNiceDate(date);
  }

  public getNiceDateHeure(date: string) {
    return this.utils.getNiceDateHeure(date);
  }

onKey(event: any) {
  
this.selectedPannes = this.searchPannes(event.target.value);
}

searchPannes(value: string) { 
  let filter = value.toLowerCase();
  return this.codesPannes.filter(option => option.nom.toLowerCase().includes(filter) || option.code.toLowerCase().includes(filter));
}


clickCall(row : CallStat){
  // const url = this.router.serializeUrl(this.router.createUrlTree(['call', row.ID_SAV_SUIVI]));
  // window.open(url,'_blank')
  window.open('call/'+ row.ID_SAV_SUIVI,'_blank')
}

onChange(event:any) {
  console.log(event)
}


}